import { createOwnerDetailsQuery } from '@hcr/api/optimizely'

import { HTTP_CONFIG } from '../../../../configs'

export const useOwnerDetailsQuery = createOwnerDetailsQuery(HTTP_CONFIG.API.Optimizely.url)
